<!-- <template>
  <b-container>
    <div v-if="isAuthenticated" />
    <div>
      <b-row class="my-4">
        <b-col cols="12">
          <h2>{{ userHandle }}'s Drops on a Map</h2>
        </b-col>
      </b-row>
      <div id="map" />
    </div>
  </b-container>
</template> -->
<template>
  <div class="mt-2">
    <div id="map" />
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import EmbedScene from '~/components/scenes/Embed'
export default {
  components: {
    EmbedScene
  },
  props: {
    currentLoc: Array,
    dropLoc: Array,
    message: String
  },
  layout: 'empty',
  data () {
    return {
      userHandle: this.$route.params.handle,
      place: this.$route.params.place,
      userDrops: [],
      userSet: '',
      dropsLoaded: false,
      mapboxToken:
        'pk.eyJ1Ijoic2hpMTEiLCJhIjoiY2x4YmNtazUwMjV5ajJscG13eTN0Z3RvdCJ9.PRPyJzGTq5GGBC50BROmBA',
      map: null,
      dropMarker: null,
      currentMarker: null,
      // At low zooms, complete a revolution every two minutes.
      secondsPerRevolution: 120,
      // Above zoom level 5, do not rotate.
      maxSpinZoom: 5,
      // Rotate at intermediate speeds between zoom levels 3 and 5.
      slowSpinZoom: 3,
      userInteracting: false,
      spinEnabled: true,
      currentCoords: [-74.5, 42]
    }
  },
  asyncData ({ req, res }) {
    return {
      baseUrl:
        'https://' +
        (process.server ? req.headers.host : window.location.hostname)
    }
  },
  watch: {
    currentLoc: {
      handler (val, oldVal) {
        if (val !== oldVal && this.map) {
          this.currentMarker.setLngLat(this.currentLoc)
          this.map.center = [this.currentLoc]
        }
      }
    }
  },
  computed: {
    ...mapState(['session', 'user', 'authToken', 'handleUser']),
    ...mapGetters(['isAuthenticated'])
  },
  async mounted () {
    if (this.$cookies.get('authToken')) {
      const response = await this.$axios.get(
        '../updatedUser/?ver=' + new Date().getTime(),
        {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('authToken')
          }
        }
      )
      await this.$store.commit('user', response.data)
      await this.$store.commit('authToken', response.data.token)
      this.$cookies.set('authToken', response.data.token)
    }

    try {
      if (this.place !== 'undefined' && this.place !== undefined && this.place !== '') {
        const response = await this.$axios.get(`/places/${this.place}`)

        this.dropsLoaded = true

        this.createMap(response.data)
      } else {
        this.$toast.console.error('The place is missing. Please go back and try again.')
      }
      // if ('geolocation' in navigator && this.locationAllowed) {
      //   this.watchId = navigator.geolocation.watchPosition(
      //     (position) => {
      //       this.currentCoords = [position.coords.longitude, position.coords.latitude]
      //       if (this.watchId) { navigator.geolocation.clearWatch(this.watchId) }
      //     },
      //     (err) => {
      //       console.log(err)
      //     },
      //     { enableHighAccuracy: true, maximumAge: 0, timeout: 20000 }
      //   )
      // }
    } catch (err) {
      debugger
      console.log(err)
    }
  },
  head () {
    return {
      script: [
        {
          src: 'https://api.mapbox.com/mapbox-gl-js/v3.4.0/mapbox-gl.js',
          defer: true
        }
      ],
      link: [
        {
          rel: 'stylesheet',
          href: 'https://api.mapbox.com/mapbox-gl-js/v3.4.0/mapbox-gl.css'
        }
      ]
    }
  },
  methods: {
    spinGlobe () {
      const zoom = this.map.getZoom()
      if (this.spinEnabled && !this.userInteracting && zoom < this.maxSpinZoom) {
        let distancePerSecond = 360 / this.secondsPerRevolution
        if (zoom > this.slowSpinZoom) {
          // Slow spinning at higher zooms
          const zoomDif =
            (this.maxSpinZoom - zoom) / (this.maxSpinZoom - this.slowSpinZoom)
          distancePerSecond *= zoomDif
        }
        const center = this.map.getCenter()
        center.lng -= distancePerSecond
        // Make animation smoother by:
        // 1. Reduce duration to make it more continuous (from 1000ms to 500ms)
        // 2. Use a smoother easing function
        // 3. Reduce the distance per frame
        this.map.easeTo({
          center,
          duration: 500,
          easing: (t) => {
            // Use cubic easing instead of linear
            return t * t * (3 - 2 * t)
          }
        })
      }
    },
    createMap (place) {
      mapboxgl.accessToken = 'pk.eyJ1Ijoic2hpMTEiLCJhIjoieGh5WE5ydyJ9.B7LtBt8hQixasCYHY9R_gA'

      this.map = new mapboxgl.Map({
        container: 'map', // container ID
        center: this.currentCoords, // starting position [lng, lat]
        zoom: 2, // starting zoom
        style: 'mapbox://styles/mapbox/satellite-streets-v12' // style URL

      })

      // Create a default Marker, colored black, rotated 45 degrees.
      // Iterate over each point in place.points

      place.points.forEach((point) => {
        // Add validation check for coordinates
        if (!point.coords || !Array.isArray(point.coords) ||
            point.coords.length !== 2 ||
            typeof point.coords[0] !== 'number' ||
            typeof point.coords[1] !== 'number') {
          console.error('Invalid coordinates found for point:', {
            pointId: point._id,
            label: point.label,
            coords: point.coords
          })
          return // Skip this point
        }

        // console.log('Processing point:', {
        //   pointId: point._id,
        //   label: point.label,
        //   coords: point.coords
        // })

        const name = point.label
        const innerHtmlContent = `<div style="min-width: 100px;font-size: small;color : black;">
            <b class="h4Class">${name} </b> </div>`
        const divElement = document.createElement('div')
        const assignBtn = document.createElement('div')
        assignBtn.innerHTML = '<button class="btn btn-info text-white" > Goto this Drop</button>'
        divElement.innerHTML = innerHtmlContent
        divElement.appendChild(assignBtn)
        // btn.className = 'btn';
        assignBtn.addEventListener('click', (e) => {
          // console.log('Button clicked' + name)
          this.$axios.get(`/pub/drop/point/${point._id}`).then((response) => {
            // console.log('Response' + response.data)
            const gotoDrop = response.data
            debugger
            if (gotoDrop.type === 'media') { window.location.href = '/m/' + gotoDrop._id } else if (gotoDrop.type === 'ar') { window.location.href = '/d/' + gotoDrop._id }
          })
        })

        // checkto makte sure point.coords[0] and point.coords[1] are numbers

        const marker = new mapboxgl.Marker({ color: 'red', rotation: 15, scale: 0.75 })
          .setLngLat({ lng: point.coords[0], lat: point.coords[1] })
          .setPopup(
            new mapboxgl.Popup({
              closeOnClick: false,
              closeButton: false
            }).setDOMContent(divElement)
            // .setHTML('<b>' + point.label + '</b>')
          )
          .addTo(this.map)
          // .setHTML('<a href=/p2d/' + point._id + '>go here</a>')

        marker.getElement().addEventListener('click', () => {
          this.map.flyTo({
            center: [point.coords[0], point.coords[1]],
            zoom: 18
          })
        })
      })

      // Only create current marker if we specifically have currentLoc
      if (this.currentLoc && Array.isArray(this.currentLoc) && this.currentLoc.length === 2) {
        const lngLat = { lng: this.currentLoc[0], lat: this.currentLoc[1] }

        this.currentMarker = new mapboxgl.Marker()
          .setLngLat(lngLat)
          .setPopup(
            new mapboxgl.Popup({
              closeOnClick: false,
              closeButton: false
            }).setHTML('<p>You are here</p>')
          )
          .addTo(this.map)
          .togglePopup()

        // Only fit bounds if we have both currentLoc and dropLoc
        if (this.dropLoc && Array.isArray(this.dropLoc) && this.dropLoc.length === 2) {
          this.map.fitBounds([this.dropLoc, this.currentLoc], {
            padding: 80
          })
        }
      }

      this.map.addControl(
        new mapboxgl.FullscreenControl({
          container: document.querySelector('body')
        })
      )

      this.map.on('style.load', () => {
        // this.map.setFog({}) // Set the default atmosphere style
        // this.map.setConfigProperty('basemap', 'lightPreset', 'day')
        // map.setConfigProperty('basemap', 'showPointOfInterestLabels', true)
        // map.setConfigProperty('basemap', 'showPlaceLabels', true)
        // map.setConfigProperty('basemap', 'showRoadLabels', true)
        // map.setConfigProperty('basemap', 'showTransitLabels', true)
      })

      // Pause spinning on interaction
      this.map.on('mousedown', () => {
        this.userInteracting = true
      })

      // Restart spinning the globe when interaction is complete
      this.map.on('mouseup', () => {
        this.userInteracting = false
        this.spinGlobe()
      })

      // These events account for cases where the mouse has moved
      // off the map, so 'mouseup' will not be fired.
      this.map.on('dragend', () => {
        this.userInteracting = false
        this.spinGlobe()
      })
      this.map.on('pitchend', () => {
        this.userInteracting = false
        this.spinGlobe()
      })
      this.map.on('rotateend', () => {
        this.userInteracting = false
        this.spinGlobe()
      })

      // When animation is complete, start spinning if there is no ongoing interaction
      this.map.on('moveend', () => {
        this.spinGlobe()
      })
      this.map.on('load', (event) => {
        event.target.resize()
        this.spinGlobe()
      })
    }
  }
}
</script>
<style scoped>
body {
  margin: 0;
  padding: 0;
}

#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}

#marker {
  cursor: pointer;
}

.mapboxgl-popup {
  max-width: 200px;
}
</style>
